import { GetStateCode } from "@/app/core/util/helpers/AutocompleteHelper";
import React, { useRef, useEffect, useState } from "react";

export default function AddressField({ address, reportAddress, teste }) {
    const [baseAdd, setBaseAdd] = useState({});
    const autoCompleteRef = useRef();
    const inputRef = useRef();
    const options = {};

    useEffect(() => {
        setBaseAdd(teste);
    }, [teste])

    useEffect(() => {
        autoCompleteRef.current = new window.google.maps.places.Autocomplete(
            inputRef.current,
            options
        );

        autoCompleteRef.current.addListener("place_changed", async function () {
            const place = await autoCompleteRef.current.getPlace();
            let base = { ...teste };
            console.log("de novo =========>", place, teste)
            if (place != undefined && address != place.formatted_address) {
                base = {};
            }
            base.address = "";
            base.address = `${place != undefined && place.formatted_address}`;
            if (place != undefined) {

                for (let s in place.address_components) {
                    const item = place.address_components[s];

                    const street = item.types.filter(x => x == "route");
                    const neighborhood = item.types.filter(x => x == "sublocality_level_1" || x == "sublocality");
                    const city = item.types.filter(x => (place.address_components.length < 7 && x == "postal_town" || x == "administrative_area_level_2") || (place.address_components.length >= 7 && x == "postal_town") || x == "locality");
                    const state = item.types.filter(x => (place.address_components.length <= 7 && x == "administrative_area_level_1") || (place.address_components.length == 7 && x == "administrative_area_level_2") || (place.address_components.length > 7 && x == "administrative_area_level_1"));
                    const country = item.types.filter(x => x == "country");
                    const zipCode = item.types.filter(x => x == "postal_code");

                    if (street.length > 0 && item.short_name != undefined) {
                        base.street = item.short_name;
                        // base.address += `${item.short_name}, `;
                    }
                    if (neighborhood.length > 0 && item.short_name != undefined) {
                        base.neighborhood = item.short_name;
                        // base.address += `${item.short_name}, `;
                    }
                    if (city.length > 0 && item.short_name != undefined) {
                        base.city = item.short_name;
                        // base.address += `${item.short_name} - `;
                    }
                    if (state.length > 0 && item.short_name != undefined) {
                        let stateName = "";
                        const names = item.short_name.split(" ");
                        if (names.length > 1) {
                            stateName = `${names[0]}${names[1]}`;
                        } else {
                            stateName = item.short_name;
                        }


                        const state = GetStateCode(stateName);
                        const stateSecond = GetStateCode(item.short_name);
                        if (item.short_name.length == 2) {
                            base.state = item.short_name;
                            base.state_code = item.short_name;
                        } else {
                            if (state == "") {
                                if (stateSecond != "") {
                                    base.state = stateSecond;
                                    base.state_code = stateSecond;
                                } else {
                                    base.state = item.short_name;
                                    base.state_code = item.short_name;
                                }
                            } else {
                                base.state = state;
                                base.state_code = state;
                            }
                        }
                        console.log("Tentou consultar", stateName, names, state);
                        // base.address += `${item.short_name} - `;
                    }

                    if (country.length > 0 && item.short_name != undefined) {
                        base.country = item.short_name;
                        base.country_code = item.short_name;
                        // base.address += `${item.short_name} - `;
                    }
                    if (zipCode.length > 0 && item.short_name != undefined) {
                        base.zipCode = item.short_name.replace("-", "");
                        base.postal_code = item.short_name.replace("-", "");
                        // base.address += `${item.short_name}`;
                    }
                }
                reportAddress(base);
            }

            console.log({ place }, base);
        });
    }, [teste]);

    return (
        <div className="form-group">
            <div className="input-group">
                <input ref={inputRef} className="form-control" defaultValue={address} id={`search`} style={{ zIndex: 20 }} />
                <div className="input-group-append">
                    <span className="input-group-text">
                        <i className="fa fa-search"></i>
                    </span>
                </div>
            </div>
        </div>
    )

}